<template>
    <b-modal
        ref="modalFilterStatements"
        lazy
        title-tag="h2"
        title="Filter Report"
        no-close-on-backdrop
    >
        <b-form-group label-for="asof" label-cols="3" label="As Of:">
            <date-picker
                v-validate="'required'"
                :config="datePickerOptions"
                :class="{ 'border-danger': errors.has('asOf') }"
                name="asOf"
                v-model="asOf"
            ></date-picker>
        </b-form-group>

        <b-form-group label-for="total-due" label-cols="3" label="Total Due:">
            <b-select v-model="totalDue">
                <option value="0">All</option>
                <option v-for="due in dueOptions" :key="due" :value="due">
                    At least {{ _currency }}{{ due.toFixed(2) }}
                </option>
            </b-select>
        </b-form-group>

        <b-form-group
            label-for="exempt-flag"
            label-cols="3"
            label="Exempt Flag:"
        >
            <b-select v-model="exemptFlag">
                <option value="1">
                    Display all clients, including those exempt from statements
                </option>
                <option value="2">
                    Display all clients, excluding those exempt from statements
                </option>
                <option value="3">
                    Display only clients exempt from statements
                </option>
            </b-select>
        </b-form-group>

        <template v-slot:modal-footer="{ cancel }">
            <loader v-if="isLoading" :margin="1" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="cancel"
                v-if="!isLoading"
            >
                Cancel
            </b-button>

            <b-button
                v-if="!isLoading"
                variant="primary"
                @click="submit"
                :disabled="disableSubmitButton"
            >
                Filter
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import Loader from "@/module/commons/loader";
import moment from "moment";

const REPORT_ACCOUNTS_RECEIVABLE_FILTER = "report/accountsReceivableFilter";

export default {
    components: {
        Loader
    },
    data() {
        return {
            datePickerOptions: {
                format: null,
                timeZone: ""
            },
            isLoading: false,
            dueOptions: [1, 10, 25, 50, 100, 250, 500]
        };
    },
    computed: {
        /**
         * we use store instead of local states because we want to persist
         * the value, even after the dialog is closed.
         */
        asOf: {
            get() {
                return this.$store.state.report.accountsReceivable.filter.asOf;
            },
            set(value) {
                this.$store.commit(REPORT_ACCOUNTS_RECEIVABLE_FILTER, {
                    key: "asOf",
                    value: value
                });
            }
        },
        totalDue: {
            get() {
                return this.$store.state.report.accountsReceivable.filter
                    .totalDue;
            },
            set(value) {
                this.$store.commit(REPORT_ACCOUNTS_RECEIVABLE_FILTER, {
                    key: "totalDue",
                    value: value
                });
            }
        },
        exemptFlag: {
            get() {
                return this.$store.state.report.accountsReceivable.filter
                    .exemptFlag;
            },
            set(value) {
                this.$store.commit(REPORT_ACCOUNTS_RECEIVABLE_FILTER, {
                    key: "exemptFlag",
                    value: value
                });
            }
        },
        disableSubmitButton() {
            if (!this.asOf || this.asOf === "") {
                return true;
            }

            return false;
        }
    },

    methods: {
        open() {
            if (!this.asOf) {
                this.asOf = moment()
                    .tz(this._timeZone)
                    .format(this.getDateFormat());
            }

            this.datePickerOptions.timeZone = this._timeZone;
            this.datePickerOptions.format = this.getDateFormat();
            this.$refs.modalFilterStatements.show();
        },
        submit() {
            this.$root.$emit("report-account-receivable-fetch", {
                to: this.asOf,
                totalDue: this.totalDue,
                exemptFlag: this.exemptFlag
            });
            this.$refs.modalFilterStatements.hide();
        }
    }
};
</script>
